// src/utils/fetchWithRetry.js
export async function fetchWithRetry(
  fn,                       // () => Promise<any>
  { retries = 3, baseDelay = 300, signal } = {}
) {
  let attempt = 0, lastErr;
  while (attempt <= retries) {
    try {
      if (signal?.aborted) throw new Error("aborted");
      return await fn({ signal });
    } catch (err) {
      if (signal?.aborted) throw err;

      // axios: err.response?.status, fetch: err.status может отсутствовать
      const status = err?.response?.status ?? err?.status;
      const nonRetryable = status && status >= 400 && status < 500 && status !== 429;
      if (nonRetryable || attempt === retries) throw err;

      const jitter = Math.random() * 100;
      const delay = Math.min(2000, baseDelay * (2 ** attempt)) + jitter;
      await new Promise(r => setTimeout(r, delay));
      lastErr = err;
      attempt++;
    }
  }
  throw lastErr;
}
